import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { CropFieldImpact } from '../../models';

@Component({
  selector: 'app-environmental-impact-table',
  templateUrl: './environmental-impact-table.component.html',
  styleUrls: ['./environmental-impact-table.component.scss'],
  standalone: false,
})
export class EnvironmentalImpactTableComponent {
  @Input() tableReportData$: Observable<CropFieldImpact[]>;
  displayedColumns = [
    'cropAidName',
    'dosage',
    'activeIngredientAmount',
    'driftReduction',
    'aquaticLife',
    'soilLife',
    'groundwaterWashout',
    'pollinators',
    'combatants',
  ];
  displayedTotalColumns = [
    'totalCaption',
    'total2',
    'totalActiveIngredientAmount',
    'total4',
    'totalAquaticLife',
    'totalSoilLife',
    'totalGroundwaterWashout',
    'total8',
    'total9',
  ];

  hasSuccessBg = (value: number): boolean => value && value < 100;
  hasAlertBg = (value: number): boolean => value >= 100 && value < 1000;
  hasWarnBg = (value: number): boolean => value >= 1000;
}
